import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import Grid from '@material-ui/core/Grid'
import { Divider } from '@material-ui/core';

import EducationModal from '../../components/educationModal';
import DeleteModal from '../../components/DeleteModal-degree';

const useStyles = makeStyles((theme) => ({
    mt: {
        marginTop: '5px'
    },
    mb: {
        marginBottom: '20px',
    },
    w8: {
        width: '80%'
    }
}))
const TalentEducationView = () => {
    const classes = useStyles();
    const [data, setData] = React.useState([]);
    const { user } = useAuth0();
    const [openNew, setOpenNew] = React.useState(false);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [openDel, setOpenDel] = React.useState(false);
    const [degree, setDegree] = React.useState({
        id: '',
        country: '',
        field: '',
        university: '',
        degree: '',
        start: '',
        end: '',
        grade: '',
        description: ''
    });
    const [update, setUpdate] = React.useState(false);

    const refreshDegrees = () => {
        setUpdate(true);
    }

    const handleNewModal = () => {
        setDegree({
            id: '',
            country: '',
            field: '',
            university: '',
            degree: '',
            start: '',
            end: '',
            grade: '',
            description: ''
        })
        setOpenNew(true);
    };

    const handleEditModal = (_degree) => {
        setDegree(_degree);
        setOpenNew(true);
    };

    const handleModalClose = () => {
        setOpenNew(false);
        setOpenEdit(false);
        setOpenDel(false);
    }

    const handleDeleteModal = (_degree) => {
        setDegree(_degree);
        setOpenDel(true)
    }

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_IP + `/talent/getdegree/${ user.sub }`)
            .then((data) => setData(data.data.Degrees))
            .then(() => setUpdate(false))
            .catch((e) => {
                console.log(e);
            });
    }, [user, update]);


    return (
        <div>
            <Grid container className={classes.mb}>
                <Grid item xs={8}>
                    <h4><strong>Education Background</strong></h4>
                </Grid>
                <Grid item xs={4}>
                    <IconButton onClick={handleNewModal}>
                        <AddIcon/>Add New
                    </IconButton>
                </Grid>                
            </Grid>
            { data.map((degree) => (
                <div>
                    <Grid container className={classes.mt}>
                    <Grid item xs={8}>
                        <p><em>{ degree.start } - { degree.end }</em></p>
                        <h5><strong>{ degree.degree } in { degree.field }</strong></h5>
                        <p>{ degree.university } - { degree.country}</p>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton onClick={() => handleEditModal(degree)}>
                            <EditIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton onClick={() => handleDeleteModal(degree)}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>                
                    </Grid>
                    <Divider className={classes.w8}/>
                </div>
            ))}
            <EducationModal degree={degree} open={openNew} onClose={handleModalClose} refresh={refreshDegrees}/>
            <EducationModal degree={degree} open={openEdit} onClose={handleModalClose} refresh={refreshDegrees}/>
            <DeleteModal degree={degree} open={openDel} onClose={handleModalClose} refresh={refreshDegrees}/>
        </div>
    );
}

export default TalentEducationView;